import React from "react";
import {
    getItineraryDebugActionButtonStyle,
    getItineraryDebugToolbarContainerStyle,
    getItineraryDebugToolbarLabelStyle,
} from "./itineraryDebugToolbar.styles";

/** Props for the list-view itinerary debug toolbar. */
export interface ItineraryDebugListToolbarProps {
    "debugItineraries": boolean;
    "isDarkUi":         boolean;
    "isDisabled":       boolean;
    "onRelaunch":       () => void;
}

/**
 * Renders the debug toolbar for the itinerary list panel.
 *
 * @param props Toolbar visibility and action wiring.
 * @returns Debug toolbar content or null when inactive.
 */
export const ItineraryDebugListToolbar: React.FC<ItineraryDebugListToolbarProps> = ( {
    debugItineraries,
    isDarkUi,
    isDisabled,
    onRelaunch,
} ) => {
    if ( !__IS_DEV__ || !debugItineraries ) {
        return null;
    }

    return (
        <div style={getItineraryDebugToolbarContainerStyle( isDarkUi )}>
            <span style={getItineraryDebugToolbarLabelStyle( isDarkUi )}>
                Debug
            </span>
            <span
                className="inline-flex items-center font-semibold"
                onClick={isDisabled ? undefined : onRelaunch}
                style={getItineraryDebugActionButtonStyle( isDarkUi, isDisabled )}
            >
                Segmentation
            </span>
        </div>
    );
};
